module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/first.js
// module id = 1034
// module chunks = 0